import React from "react";
import "../scss/UnsupportedBrowserComponent.css";

export default function UnsupportedBrowserComponent({isOnMobile}) {
    return (
        <div className="unsupported-browser-container">
            <div className="unsupported-browser-content">
                <img
                    src="/images/access-denied.png"
                    alt="Unsupported Browser"
                    className="unsupported-browser-image"
                />

               {isOnMobile?        
               <h2 className="unsupported-browser-title">Unsupported Browser</h2>
               :<h2 className="unsupported-browser-title">Unsupported Device</h2>}
                {!isOnMobile?
                    <p className="unsupported-browser-message">
                        To continue, please use a <strong>mobile device</strong>.
                    </p>:
                    <p className="unsupported-browser-message">
                        To continue, please use one of the supported browsers:
                    </p>
                }
               
                {isOnMobile && <ul className="unsupported-browser-list">
                    <li>
                        <a href="https://www.google.com/chrome/" target="_blank" rel="noopener noreferrer">
                            <img src="/images/chrome.webp" alt="Chrome" className="browser-icon" />
                            Google Chrome
                        </a>
                    </li>
                    <li>
                        <a href="https://www.apple.com/safari/" target="_blank" rel="noopener noreferrer">
                            <img src="/images/safari.webp" alt="Safari" className="browser-icon" />
                            Safari
                        </a>
                    </li>
                    <li>
                        <a href="https://www.microsoft.com/edge" target="_blank" rel="noopener noreferrer">
                            <img src="/images/edge.webp" alt="Edge" className="browser-icon" />
                            Microsoft Edge
                        </a>
                    </li>
                    <li>
                        <a href="https://apps.samsung.com/appquery/appDetail.as?appId=com.sec.android.app.sbrowser" target="_blank" rel="noopener noreferrer">
                            <img src="/images/samsung.jpg" alt="Samsung Internet" className="browser-icon" />
                            Samsung Internet
                        </a>
                    </li>

                     <li>
                        <a href="https://www.opera.com/mobile" target="_blank" rel="noopener noreferrer">
                            <img src="/images/opera.webp" alt="Opera" className="browser-icon" />
                            Opera
                        </a>
                    </li>

                     <li>
                        <a href="https://www.ucweb.com/" target="_blank" rel="noopener noreferrer">
                            <img src="/images/uc.jpg" alt="UC Browser" className="browser-icon" />
                           UC Browser
                        </a>
                    </li>
                </ul>}
                {isOnMobile && <p className="unsupported-browser-note">
                    Your current browser does not support secure, camera-only uploads.
                </p>}
                <button
                    onClick={() => window.location.href = "/"}
                    className="unsupported-browser-retry orange-theme"
                >
                    Okay
                </button>
            </div>
        </div>
    );
}
